export const RESTAURANT_NAME = "MÂJI by Cerón";
export const RESTAURANT_TAGLINE = "Cocina Colombo-Asiática";
export const RESTAURANT_ADDRESS =
  "Carrera 5 #7-34, Mall La Herrería, Salento, Quindío, Colombia";
export const RESTAURANT_PHONE = "+57 302 6095958";

export const WHATSAPP_LINK =
  "https://wa.me/573026095958?text=Hola%20M%C3%82JI%2C%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20para%20visitarlos.";

export const MAPS_DIRECTIONS_LINK =
  "https://www.google.com/maps/dir/?api=1&destination=M%C3%82JI+by+Cer%C3%B3n%2C+Carrera+5+%237-34%2C+Salento%2C+Quind%C3%ADo";

export const MAPS_EMBED_SRC =
  "https://www.google.com/maps?q=M%C3%82JI+by+Cer%C3%B3n+Salento+Quind%C3%ADo&output=embed";

export const MENU_LINK = "https://menu.majibyceron.com/";

export const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Moody%20editorial%20food%20photography%20of%20a%20steaming%20bowl%20of%20ramen%20on%20a%20dark%20charcoal%20wooden%20table%2C%20warm%20amber%20side%20light%2C%20gentle%20steam%2C%20dark%20blurred%20background%2C%20ceramic%20bowl%20close%20up%2C%20intimate%20elegant%20restaurant%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20cinematic%20warm%20tones&width=1920&height=1080&seq=maji-hero-ramen&orientation=landscape";